<div class="action-list animate__animated animate__fadeInDown animate__faster">
    <div class="contenido">
        <h1>Juego publicado</h1>

        <div class="pasos">

        </div>
        <!--premium -->
        <div *ngIf="state_premium==1" class="paso3">

            <mat-card-content>
                <span>Link del juego</span>

                <input class="form-control" type="text" ngDefaultControl [(ngModel)]="url" disabled>
                <span>Comparte con el lin embed</span>

                <textarea ngDefaultControl [(ngModel)]="iframe" disabled></textarea>
                
                <!--span>¿DESEAS AGREGAR UNA CLAVE A TU JUEGO? INGRESALA AQUÍ</span>
                <input class="form-control" type="text" [(ngModel)]="clave" (blur)="createClave()"-->

                <span>Genera el juego y publicar</span>

            </mat-card-content>

        </div>


        <div class="btn-action">
            <button mat-button (click)="publicar()">Volver a generar juego</button>
            <!--button *ngIf="state_premium==1" mat-button>Descarga el código del juego
            </button-->
        </div>
        <div class="btn-action" *ngIf="esperaFinal">
            <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <button mat-button class="btn-close"><img src="assets/icons/plus.png" (click)="close()"></button>
    </div>
</div>